import { Star } from 'lucide-react';

const ReviewCard = ({ review }) => {
  return (
    <div className="card-review" data-testid={`review-card-${review.id}`}>
      <div className="flex items-center gap-1 mb-3">
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            className={`w-4 h-4 ${
              star <= review.rating ? 'fill-amber-400 text-amber-400' : 'fill-stone-200 text-stone-200'
            }`}
          />
        ))}
        <span className="ml-2 text-sm text-stone-500">{review.rating}/5</span>
      </div>
      <p className="text-stone-700 text-sm leading-relaxed mb-4">
        "{review.comment}"
      </p>
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
          <span className="text-emerald-700 font-semibold text-sm">
            {review.author_name.charAt(0).toUpperCase()}
          </span>
        </div>
        <div>
          <p className="font-medium text-stone-900 text-sm">{review.author_name}</p>
          <p className="text-xs text-stone-500">Client vérifié</p>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
